import React, { useState } from "react";
import { Box, Layer, Text, Button, TextArea, Select } from "grommet";
import { FormClose, Info } from "grommet-icons";

const EditQuestionModal = ({ question, courses, onSubmit, onCancel }) => {
  const [editedText, setEditedText] = useState(question.question);
  const [editedType, setEditedType] = useState(
    question.weight === 1 ? "Y/N" : question.weight === 2 ? "Range" : "",
  );
  const [selectedCourse, setSelectedCourse] = useState(
    `${question.course_code} - ${question.course_name}`,
  );

  const isUnchanged =
    editedText === question.question &&
    editedType ===
      (question.weight === 1 ? "Y/N" : question.weight === 2 ? "Range" : "") &&
    selectedCourse === `${question.course_code} - ${question.course_name}`;

  return (
    <Layer modal onEsc={onCancel} responsive={false}>
      <Box pad="medium" gap="medium" width="large">
        <Box direction="row" justify="between" align="center">
          <Text weight="bold" size="large">
            Edit Question
          </Text>
          <Button icon={<FormClose />} onClick={onCancel} size="large" />
        </Box>

        {/* Question Text */}
        <Box gap="small">
          <Text weight="bold">Question</Text>
          <TextArea
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            resize="vertical"
          />
        </Box>

        {/* Question Type */}
        <Box gap="small">
          <Text weight="bold">Question Type</Text>
          <Select
            options={["Y/N", "Range"]}
            value={editedType}
            onChange={({ option }) => setEditedType(option)}
          />
        </Box>

        {/* Course (still editable) */}
        <Box gap="small">
          <Text weight="bold">Course</Text>
          <Select
            options={courses}
            labelKey="label"
            valueKey="value"
            value={selectedCourse}
            onChange={({ option }) => setSelectedCourse(option.value)}
          />
        </Box>

        <Box
          direction="row"
          align="center"
          gap="small"
          pad={{ left: "small", right: "small", vertical: "small" }}
          border={{ color: "status-info", size: "xsmall" }}
          background="light-2"
          round="small"
        >
          <Info color="brand" size="large" />
          <Text size="small">
            Changing the course will automatically update the mapped learning
            path.
          </Text>
        </Box>

        {/* Learning Path (read-only) */}
        <Box gap="small">
          <Text weight="bold">Learning Path</Text>
          <Text>{question.learning_path_name}</Text>
        </Box>

        {/* Action Buttons */}
        <Box
          direction="row"
          justify="end"
          gap="small"
          margin={{ top: "medium" }}
        >
          <Button label="Cancel" onClick={onCancel} />
          <Button
            label="Submit"
            primary
            onClick={() =>
              onSubmit({
                ...question,
                question: editedText,
                weight: editedType === "Y/N" ? 1 : 2,
                course_name: selectedCourse,
                // learning_path_name left unchanged
              })
            }
            disabled={isUnchanged}
          />
        </Box>
      </Box>
    </Layer>
  );
};

export default EditQuestionModal;
